import { NavLink, useNavigate } from 'react-router-dom';
import { UseLogOut } from '../../hooks/UseLogOut';
import { UseAuthContext } from '../../hooks/UseAuthContext';
import { toast } from 'react-toastify';

import { Navbar, Nav, Container } from 'react-bootstrap';
import { GeoAltFill, PersonCircle, BoxArrowRight } from 'react-bootstrap-icons';

import './Header.css';


const Header = () => {

    const { logout } = UseLogOut();
    const { user } = UseAuthContext();
    const navigate = useNavigate();


    const handleClick = () => {

        logout();

        toast.error('User Logged Out');

        navigate('/login');

    };


    return (

        <header className="site-header">

            <Container>

                <Navbar expand="lg" className="travel-navbar">

                    <Navbar.Brand as={NavLink} to="/" className="travel-logo">
                        Travel<span>Pals</span>
                    </Navbar.Brand>


                    <Navbar.Toggle
                        aria-controls="travel-navbar-nav"
                        className="travel-navbar-toggle"
                    />


                    <Navbar.Collapse id="travel-navbar-nav">

                        <Nav className="ms-auto travel-nav">

                            <Nav.Link
                                as={NavLink}
                                to="/find"
                                className="nav-item-custom"
                            >
                                <GeoAltFill />
                                Find Places
                            </Nav.Link>


                            {!user && (

                                <>

                                    <Nav.Link
                                        as={NavLink}
                                        to="/login"
                                        className="nav-item-custom"
                                    >
                                        Login
                                    </Nav.Link>


                                    <Nav.Link
                                        as={NavLink}
                                        to="/signup"
                                        className="nav-register"
                                    >
                                        Register
                                    </Nav.Link>

                                </>

                            )}


                            {user && (

                                <>

                                    <Nav.Link
                                        as={NavLink}
                                        to="/place"
                                        className="nav-item-custom"
                                    >
                                        <PersonCircle />
                                        Profile
                                    </Nav.Link>


                                    <button
                                        onClick={handleClick}
                                        className="nav-logout"
                                        aria-label="Logout"
                                    >
                                        <BoxArrowRight />
                                    </button>

                                </>

                            )}

                        </Nav>

                    </Navbar.Collapse>

                </Navbar>

            </Container>

        </header>

    );

};


export default Header;